import { render } from "./SysAdmin.vue?vue&type=template&id=b0c78cfe&scoped=true"
import script from "./SysAdmin.vue?vue&type=script&lang=js"
export * from "./SysAdmin.vue?vue&type=script&lang=js"

import "./SysAdmin.vue?vue&type=style&index=0&id=b0c78cfe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0c78cfe"]])

export default __exports__